import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import { useSearchAssistant } from '../../../hooks/remoteSearchSelect/useSearchAssistant';
import { useSearchTeachers } from '../../../hooks/remoteSearchSelect/useSearchTeachers';
import CreateAssistantButton from './CreateAssistantButton';
import ExtraFields from './ExtraFields';

type SectionTeacherFieldsProps = {
  sectionId: string;
  supportsOnline?: boolean;
  supportsPresential?: boolean;
  setIsModalOpen: (value: boolean) => void;
};

const SectionTeacherFields = ({
  sectionId,
  supportsOnline = false,
  supportsPresential = false,
  setIsModalOpen,
}: SectionTeacherFieldsProps) => {
  const { t } = useTranslation();
  const prefix = 'sectionsMaintainer.update';

  const searchTeachers = useSearchTeachers(sectionId);
  const searchAssistants = useSearchAssistant(sectionId);

  return (
    <Row>
      <Col xs={12} md={6}>
        <ExtraFields
          title="teachers"
          inputLabel={t(`${prefix}.teacher`)}
          search={searchTeachers}
          buttonLabel={t(`${prefix}.addTeacher`)}
          supportsOnline={supportsOnline}
          supportsPresential={supportsPresential}
        />
      </Col>
      <Col xs={12} md={6}>
        <ExtraFields
          title="assistants"
          inputLabel={t(`${prefix}.assistant`)}
          search={searchAssistants}
          buttonLabel={t(`${prefix}.addAssistant`)}
          supportsOnline={supportsOnline}
          supportsPresential={supportsPresential}
          children={
            <CreateAssistantButton onClick={() => setIsModalOpen(true)} />
          }
        />
      </Col>
    </Row>
  );
};

export default SectionTeacherFields;
